import { render } from "./TnAlipayCoupons.vue?vue&type=template&id=0aba92a9"
import script from "./TnAlipayCoupons.vue?vue&type=script&lang=js"
export * from "./TnAlipayCoupons.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__